export const FULLSTORY_EXCLUDE_CLASS = 'fs-exclude';
export const FULLSTORY_MASK_CLASS = 'fs-mask';
